var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{attrs:{"id":"nav"}},[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Play")]),_vm._v(" | "),_c('router-link',{attrs:{"to":"/about"}},[_vm._v("Notes")])],1),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }